import React from "react";

import { ArrowDownward, ArrowUpward, InfoOutlined } from "@mui/icons-material";
import { Box, Stack, Tooltip } from "@mui/material";

import { IconButton } from "@/components/Button";
import { Spacer } from "@/components/Spacer/Spacer";
import { Label, Overline1Bold } from "@/components/Typography";
import { OrderByDirection } from "@/gql/graphql";
import { colors } from "@/theme/overrides/colors";

interface ClientStatusHeaderProps {
  sortDirection: OrderByDirection;
  onSortButtonClick: () => void;
}

export const ClientStatusHeader: React.FC<ClientStatusHeaderProps> = ({
  sortDirection,
  onSortButtonClick,
}) => {
  return (
    <Box display="flex" width="100%" alignItems="center" px={4}>
      <Stack direction="row" flex={1} alignItems="center">
        <Overline1Bold text="Name" />
        <IconButton
          icon={
            sortDirection === OrderByDirection.Asc ? (
              <ArrowUpward color="primary" />
            ) : (
              <ArrowDownward color="primary" />
            )
          }
          size="smaller"
          onClick={onSortButtonClick}
        />
      </Stack>
      <Box flex={1}>
        <Overline1Bold text="Program" />
      </Box>
      <Stack direction="row" flex={1} alignItems="center">
        <Overline1Bold text="Status" />
        <Spacer w={8} />
        <Tooltip
          arrow
          placement="right-start"
          slotProps={{
            tooltip: {
              sx: {
                color: colors.mapped.surface.systemWhite,
                backgroundColor: "#112340",
              },
            },
          }}
          title={
            <Box p="8px">
              <Label
                color={colors.mapped.surface.systemWhite}
                text="For Food Journaling, client can be tagged as:"
              />
              <ul style={{ paddingLeft: 20 }}>
                <li>
                  <Label
                    color={colors.mapped.surface.systemWhite}
                    text="Active: If they logged a meal within 3 days"
                  />
                </li>
                <li>
                  <Label
                    color={colors.mapped.surface.systemWhite}
                    text="Struggling, if no meal logs for 3 days"
                  />
                </li>
                <li>
                  <Label
                    color={colors.mapped.surface.systemWhite}
                    text="Inactive, if no meal logs for 7 days"
                  />
                </li>
              </ul>
            </Box>
          }
        >
          <InfoOutlined color="primary" />
        </Tooltip>
      </Stack>
    </Box>
  );
};
